<div class="transport-registration-masterdata">
    <app-centered-scrollable-content>

        <div *ngIf="requiresValueConfirmation">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-masterdata.confirmation.description"></sc-dictionary-label>
            <sc-content-spacer vertical></sc-content-spacer>
        </div>

        <div class="details-mask">
            <sc-dictionary-label dictionaryKey="tmc-yard.registration-terminal.ui.transport-registration-masterdata.mandatoryfields.hint"></sc-dictionary-label>
            <app-transport-details [mode]="TransportDetailMode.EDITING" [layout]="layoutDefinition"
                [transport]="transportDetails" (valueChange)="onTransportDetailsChanged()"
                (validState)="validStateChanged($event)" [disableAutoComplete]="true">
            </app-transport-details>
            <!-- features nachziehen -->
            <!--app-transport-details [mode]="TransportDetailMode.EDITING" [layout]="layoutDefinition"
            [requiresValueConfirmation]="requiresValueConfirmation" [showHints]="showHints" [transport]="transportDetails"
            [autocompletionEnabled]="false" (transportDetailsChanged)="onTransportDetailsChanged()" (validState)="validStateChanged($event)">
        </app-transport-details-->
        </div>
    </app-centered-scrollable-content>
</div>
